import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ParkingMarker from './markers/ParkingMarker';
import ParkingCluster from './markers/ParkingCluster';
export default function Markers({ markers, testId, onParkingClick, onClusterClick }) {
    const handleParkingClick = (marker) => onParkingClick(marker);
    const handleClusterClick = (cluster) => onClusterClick(cluster);
    return (_jsx(_Fragment, { children: markers.map((entity) => {
            if (entity.type === 'marker') {
                return (_jsx(ParkingMarker, { position: entity.position, isSelected: entity.isSelected ?? false, lotMode: entity.lotMode ?? false, onClick: () => handleParkingClick(entity), testId: testId.append('marker').append(entity.parkingSlug) }, `marker-${entity.parkingSlug}`));
            }
            else if (entity.type === 'cluster') {
                return (_jsx(ParkingCluster, { position: entity.position, counter: entity.members.length, onClick: () => handleClusterClick(entity), testId: testId.append('cluster').append(entity.key) }, `cluster-${entity.key}`));
            }
        }) }));
}
